import exceptionIcon from '@jetbrains/icons/exception.svg'
import ErrorMessage from '@jetbrains/ring-ui/components/error-message/error-message'
import React, {Suspense} from 'react'

import ErrorBoundary from '../../../common/ErrorBoundary/ErrorBoundary'
import Loader from '../../../common/Loader/Loader'
import usePipelineDocumentTitle from '../hooks/usePipelineDocumentTitle'
import {serializeError} from '../utils/error'

import IndexHeader from './IndexHeader/IndexHeader'
import PipelineList from './PipelineList/PipelineList'
import {usePipelineProjectsLocator} from './PipelineList/PipelineList.hooks'

import styles from './IndexPage.css'

function IndexPage() {
  usePipelineDocumentTitle('List')
  const projectsLocator = usePipelineProjectsLocator()

  return (
    <div className={styles.page}>
      <IndexHeader />
      <div className={styles.pipelineList}>
        <ErrorBoundary
          fallbackRender={({error}) => (
            <ErrorMessage
              icon={exceptionIcon}
              message="Error while loading project list"
              description={serializeError(error)}
            />
          )}
        >
          <Suspense fallback={<Loader />}>
            {projectsLocator != null ? (
              <PipelineList projectsLocator={projectsLocator} />
            ) : (
              <Loader />
            )}
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  )
}

export default IndexPage
